export const NANO_COEFFICIENT = 1_000_000_000;

export const getTraceProcessingTime = span => span.duration[0] * NANO_COEFFICIENT + span.duration[1];
